import React from 'react'
import { arrayOf, any, string, object } from 'prop-types'
import { navigate } from '@helpers/link'
import sortBy from 'lodash/sortBy'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'

import { productAvailability } from '@helpers/product'
import { productUrl } from '@helpers/route'
import ProductVariation from './product-variation-refactor'
import ProductSelectVariation from './product-select-variation'

const ProductVariations = ({ variations, heading, productSku, className, location }) => {
  const availableVariations = variations
    ? variations.filter(v => productAvailability(v, location?.region) || !v.catalog_availability)
    : []

  if (!availableVariations) return null
  const colors = availableVariations[availableVariations.findIndex(v => v.sku === productSku)]?.variation_value || false
  if (!colors) return null

  if (heading === 'Size') {
    return (
      <ProductSelectVariation
        variations={availableVariations}
        heading="Size"
        productSku={productSku}
        handleChange={value =>
          navigate(productUrl(availableVariations.filter(i => i.variation_value === value)[0].route))
        }
        className={className}
      />
    )
  }
  return (
    <Grid container direction="column" justifyContent="flex-start">
      <Box display="flex">
        <span>{`${heading}: `}</span>
        <Box fontWeight={700} ml="15px">
          {colors}
        </Box>
      </Box>
      <Grid container justifyContent="flex-start">
        {sortBy(availableVariations, 'variation_value').map((v, i) => (
          <ProductVariation
            key={v.sku}
            image={v.image}
            variation_value={v.variation_value}
            index={i}
            active={productSku === v.sku}
            route={v.route}
            sku={v.sku}
            variation={v}
          />
        ))}
      </Grid>
    </Grid>
  )
}

ProductVariations.propTypes = {
  variations: arrayOf(any),
  heading: string,
  productSku: string,
  className: string,
  location: object,
}

export default ProductVariations
